/*
  Header behaviour: scroll state, mega-menu dropdowns, mobile drawer,
  predictive search overlay, cart count. Plain ES2020, progressive.
  No dependencies. Relies on window.JT (theme.js) when available.
*/
(function () {
  'use strict';

  var doc = document;
  var header = doc.querySelector('[data-header]');
  var body = doc.body;

  /* ---------- sticky / scrolled state ---------- */
  if (header && !header.classList.contains('site-header--static')) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- desktop dropdowns ---------- */
  var navItems = Array.prototype.slice.call(doc.querySelectorAll('[data-nav-item]'));
  navItems.forEach(function (item) {
    var trigger = item.querySelector('.nav-item__trigger');
    var panel = item.querySelector('[data-nav-panel]');
    if (!trigger || !panel) return;
    var closeTimer = null;

    var open = function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      navItems.forEach(function (other) {
        if (other !== item) closePanel(other);
      });
      item.classList.add('is-open');
      panel.setAttribute('data-open', 'true');
      panel.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
    };
    var close = function () {
      item.classList.remove('is-open');
      panel.setAttribute('data-open', 'false');
      panel.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    };
    var scheduleClose = function () {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 150);
    };

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (item.classList.contains('is-open')) close(); else open();
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      if (e.key === 'Escape') close();
    });
    panel.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) scheduleClose();
    });
  });

  function closePanel(item) {
    var panel = item.querySelector('[data-nav-panel]');
    var trigger = item.querySelector('.nav-item__trigger');
    item.classList.remove('is-open');
    if (panel) { panel.setAttribute('data-open', 'false'); panel.setAttribute('aria-hidden', 'true'); }
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  /* ---------- mobile drawer ---------- */
  var drawer = doc.querySelector('[data-drawer]');
  var lastFocused = null;

  function drawerOpen() {
    if (!drawer) return;
    lastFocused = doc.activeElement;
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    body.classList.add('is-drawer-open');
    doc.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusable = drawer.querySelector('a[href], button:not([disabled])');
    if (focusable) focusable.focus();
  }
  function drawerClose() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    body.classList.remove('is-drawer-open');
    doc.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  doc.querySelectorAll('[data-drawer-open]').forEach(function (b) {
    b.addEventListener('click', drawerOpen);
  });
  doc.querySelectorAll('[data-drawer-close]').forEach(function (b) {
    b.addEventListener('click', drawerClose);
  });

  // drawer accordions
  doc.querySelectorAll('[data-drawer-accordion] .drawer__toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var item = toggle.closest('[data-drawer-accordion]');
      var isOpen = item.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  // focus trap
  if (drawer) {
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var nodes = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- search overlay ---------- */
  var overlay = doc.querySelector('[data-search-overlay]');
  var searchInput = doc.querySelector('[data-search-input]');
  var results = doc.querySelector('[data-search-results]');
  var spinner = doc.querySelector('[data-search-spinner]');
  var clearBtn = doc.querySelector('[data-search-clear]');
  var searchTimer = null;

  function searchOpen() {
    if (!overlay) return;
    overlay.setAttribute('data-open', 'true');
    overlay.setAttribute('aria-hidden', 'false');
    body.classList.add('is-search-open');
    doc.querySelectorAll('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 100);
  }
  function searchClose() {
    if (!overlay) return;
    overlay.setAttribute('data-open', 'false');
    overlay.setAttribute('aria-hidden', 'true');
    body.classList.remove('is-search-open');
    doc.querySelectorAll('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  doc.querySelectorAll('[data-search-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (body.classList.contains('is-search-open')) searchClose(); else searchOpen();
    });
  });
  doc.querySelectorAll('[data-search-close]').forEach(function (b) {
    b.addEventListener('click', searchClose);
  });

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function label(name, fallback) {
    var v = overlay && overlay.getAttribute('data-label-' + name);
    return v || fallback;
  }

  function renderResults(query, products) {
    if (!results) return;
    if (!products || !products.length) {
      results.innerHTML =
        '<div class="search-overlay__empty">' +
        '<svg class="icon" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m21 21-4.34-4.34"/><circle cx="11" cy="11" r="8"/></svg>' +
        '<p>' + escapeHtml(label('no-results', 'No results for')) + ' <strong>' + escapeHtml(query) + '</strong></p></div>';
      return;
    }
    var html = '<div class="search-results__head">' + escapeHtml(label('top-results', 'Top results')) + ' (' + products.length + ')</div>';
    products.forEach(function (p) {
      var img = (p.featured_image && p.featured_image.url) || (p.image) || '';
      if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=128';
      var rawPrice = p.price != null ? p.price : p.price_min;
      var price = '';
      if (rawPrice != null) {
        var cents = typeof rawPrice === 'string' ? Math.round(parseFloat(rawPrice) * 100) : rawPrice;
        price = window.JT && window.JT.formatMoney ? window.JT.formatMoney(cents) : String(rawPrice);
      }
      html +=
        '<a class="search-result" href="' + escapeHtml(p.url) + '">' +
        (img ? '<img class="search-result__thumb" src="' + escapeHtml(img) + '" alt="" loading="lazy" width="64" height="64">' : '<span class="search-result__thumb"></span>') +
        '<span class="search-result__info">' +
        '<span class="search-result__title">' + escapeHtml(p.title) + '</span>' +
        (p.product_type ? '<span class="search-result__type">' + escapeHtml(p.product_type) + '</span>' : '') +
        '</span>' +
        '<span class="search-result__price">' + escapeHtml(price) + '</span>' +
        '</a>';
    });
    var allUrl = overlay.getAttribute('data-search-url') || '/search';
    html +=
      '<a class="search-results__footer" href="' + escapeHtml(allUrl) + '?q=' + encodeURIComponent(query) + '">' +
      escapeHtml(label('view-all', 'View all results')) + '</a>';
    results.innerHTML = html;
  }

  function runSearch() {
    if (!overlay || !searchInput) return;
    var query = searchInput.value.trim();
    if (clearBtn) clearBtn.hidden = query.length === 0;
    if (query.length < 1) {
      if (results) { results.hidden = true; results.innerHTML = ''; }
      if (spinner) spinner.hidden = true;
      return;
    }
    var base = overlay.getAttribute('data-predictive-url') || '/search/suggest';
    if (base.indexOf('.json') === -1) base += '.json';
    var url =
      base +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=8' +
      '&resources[options][fields]=title,product_type,variants.title';
    if (spinner) spinner.hidden = false;
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products =
          data && data.resources && data.resources.results && data.resources.results.products;
        renderResults(query, products);
        if (results) results.hidden = false;
      })
      .catch(function () {
        if (results) { results.hidden = true; }
      })
      .finally(function () {
        if (spinner) spinner.hidden = true;
      });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      if (searchTimer) clearTimeout(searchTimer);
      searchTimer = setTimeout(runSearch, 400);
    });
  }
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (searchInput) searchInput.value = '';
      if (results) { results.hidden = true; results.innerHTML = ''; }
      clearBtn.hidden = true;
      if (searchInput) searchInput.focus();
    });
  }

  /* ---------- escape closes everything ---------- */
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (body.classList.contains('is-search-open')) searchClose();
    if (body.classList.contains('is-drawer-open')) drawerClose();
    navItems.forEach(closePanel);
  });

  /* ---------- cart ---------- */
  function updateCartCount() {
    if (!header) return;
    var cartUrl = header.getAttribute('data-cart-url') || '/cart';
    fetch(cartUrl + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = (cart && cart.item_count) || 0;
        doc.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = count;
          el.hidden = count === 0;
        });
      })
      .catch(function () {});
  }

  doc.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      doc.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    });
  });

  doc.addEventListener('cart:updated', updateCartCount);
  doc.addEventListener('cart:refresh', updateCartCount);
  updateCartCount();

  /* ---------- footer: scroll to top ---------- */
  doc.querySelectorAll('[data-scroll-top]').forEach(function (b) {
    b.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
})();
